export default __webpack_public_path__ + "src/images/packages/bundox-safari-lodge/d8517f83a1742b44376a899408b1bea7-3.jpg";